import { AxiosResponse } from 'axios';
import SecureClient from '../SecureClient';
import { TandemLicenseInfo } from './DTOs';

export default class TandemClient extends SecureClient {

	public getLicenseInfo = (): Promise<AxiosResponse<TandemLicenseInfo>> => {
		return this._api.get<TandemLicenseInfo>('Tandem/LicenseInfo', {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}
}